<template>
  <modal titulo="Registro Anterior — Importação" :loading="loading">

    <card titulo="Tipo de Registro Anterior">
      <card-content class="row gutters-xs">
        <div class="col-12">
          <v-input v-model="form.tipo" label="Tipo" type="select" :options="tiposRegistro" :error="validation.tipo" @change="onChangeTipo"/>
        </div>
      </card-content>
    </card>

    <card titulo="Número do Registro Anterior" class="mt-2">
      <card-content class="row gutters-xs">
        <div class="col-4">
          <v-input v-model="form.tipoNumero" label="Tipo" type="select" :options="tiposNumero"/>
        </div>
        <div class="col-8" v-if="form.tipoNumero === 'C'">
          <v-input v-model="form.coluna1" :label="isMatriculaExterna ? 'Registro' : 'Coluna'" type="select" :options="colunasOptions" :error="validation.numero"/>
        </div>
        <template v-else-if="form.tipoNumero === 'F' && isMatricula">
          <div class="col-8">
            <label style="margin-left: 22px">Registro</label>
            <buscar-fichas :livro="tipoAtual.livro" :status="tipoAtual.status" :full="true" :multiple="false"
                           :valorInicialIndividual="valorInicialFicha" :error="validation.numero"
                           @selecionar="selecionarFicha" ref="buscarFichas"/>
          </div>
        </template>
        <template v-else-if="form.tipoNumero === 'F' && isMatriculaExterna">
          <div class="col-8">
            <buscar-fichas-externas :livro="form.tipoIndicadorFixo" :selecionarLivros="true" :full="true" :multiple="false"
                                    :valorInicialIndividual="valorInicialFicha"
                                    :error="validation.numero || validation.tipoIndicadorFixo"
                                    @selecionar="selecionarFicha" ref="buscarFichasExternas"/>
          </div>
        </template>
        <div class="col-8" v-else>
          <v-input v-model="form.fixo" label="Fixo" type="text" :error="validation.numero"/>
        </div>
      </card-content>
    </card>

    <card titulo="Tipo do Indicador" class="mt-2" v-if="isMatriculaExterna && form.tipoNumero === 'C'">
      <card-content class="row gutters-xs">
        <div class="col-4">
          <v-input v-model="form.tipoIndicadorTipo" label="Tipo Indicador" type="select" :options="tiposNumero" :error="validation.tipoIndicadorTipo" @change="onChangeTipoIndicador"/>
        </div>
        <div class="col-8" v-if="form.tipoIndicadorTipo === 'F'">
          <v-input v-model="form.tipoIndicadorFixo" label="Indicador" type="select" :options="tiposIndicadorFixo" :error="validation.tipoIndicadorFixo"/>
        </div>
        <div class="col-8" v-else>
          <v-input v-model="form.tipoIndicadorColuna" label="Coluna" type="select" :options="colunasOptions" :error="validation.tipoIndicadorColuna"/>
        </div>
      </card-content>
    </card>

    <card titulo="Serventia do Registro Anterior" class="mt-2" v-if="isMatriculaExterna">
      <card-content class="row gutters-xs">
        <div class="col-12">
          <v-input v-model="form.serventia" label="Serventia" type="select" :options="serventias" :error="validation.serventia"/>
        </div>
      </card-content>
    </card>

    <card titulo="Complemento" class="mt-2">
      <card-content class="row gutters-xs">
        <div class="col-12">
          <v-input v-model="form.complemento" label="Complemento" type="text"/>
        </div>
      </card-content>
    </card>

    <template #footer>
      <button type="button" @click.prevent="cancelar()" class="btn btn-outline-secondary mr-auto">
        Cancelar
      </button>
      <v-button :run="salvar" class="btn btn-outline-primary">Salvar</v-button>
    </template>

  </modal>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import IndicadorRealBusiness from "@/business/indicadores/IndicadorRealBusiness";
import Card from "@/components/Layout/components/Card";
import CardContent from "@/components/Layout/components/CardContent";
import Modal from "@/components/Modal";

export default {
  name: "RegistroAnteriorImportacao",
  components: {Modal, Card, CardContent},
  props: {
    colunas: {type: Array, default: () => []},
    serventias: {type: Array, default: () => []},
    registroEditar: {type: Object, default: null},
  },

  modal: {
    width: 800
  },

  data() {
    const form = this.registroEditar
      ? {
          tipo: this.registroEditar.tipo || null,
          tipoNumero: this.registroEditar.numero?.tipo || 'F',
          coluna1: this.registroEditar.numero?.coluna1 || null,
          fixo: this.registroEditar.numero?.fixo || null,
          livroNumero: this.registroEditar.numero?.livroNumero || null,
          livroLetra: this.registroEditar.numero?.livroLetra || null,
          livroFolha: this.registroEditar.numero?.livroFolha || null,
          serventia: this.registroEditar.serventia || null,
          complemento: this.registroEditar.complemento || null,
          tipoIndicadorTipo: this.registroEditar.tipoIndicador?.tipo || 'F',
          tipoIndicadorFixo: this.registroEditar.tipoIndicador?.fixo || 'MATRICULA',
          tipoIndicadorColuna: this.registroEditar.tipoIndicador?.coluna || null,
        }
      : {
          tipo: null,
          tipoNumero: 'F',
          coluna1: null,
          fixo: null,
          livroNumero: null,
          livroLetra: null,
          livroFolha: null,
          serventia: null,
          complemento: null,
          tipoIndicadorTipo: 'F',
          tipoIndicadorFixo: 'MATRICULA',
          tipoIndicadorColuna: null,
        };

    return {
      loading: false,
      form,
      validation: {},
      tiposRegistro: IndicadorRealBusiness.getTiposOrigens().filter(t =>
        ['MATRICULA', 'TRANSCRICAO', 'MATRICULA_EXTERNA'].includes(t.id)
      ),
      tiposNumero: [
        {id: 'C', nome: 'Coluna'},
        {id: 'F', nome: 'Fixo'},
      ],
      tiposIndicadorFixo: [
        {id: 'MATRICULA', nome: 'Matrícula'},
        {id: 'TRANSCRICAO', nome: 'Transcrição'},
        {id: 'TORRENS', nome: 'Torrens'},
      ],
    }
  },

  computed: {
    colunasOptions() {
      return (this.colunas || []).map(c => ({id: c, nome: 'Coluna: "' + c + '"'}));
    },

    isMatricula() {
      return ['MATRICULA', 'TRANSCRICAO', 'PRE_MATRICULA'].includes(this.form.tipo);
    },

    isMatriculaExterna() {
      return this.form.tipo === 'MATRICULA_EXTERNA';
    },

    tipoAtual() {
      return IndicadorRealBusiness.getTiposOrigens().find(t => t.id === this.form.tipo) || {};
    },

    livroFichaAtual() {
      return this.isMatriculaExterna ? this.form.tipoIndicadorFixo : this.form.tipo;
    },

    mensagemNumeroObrigatorio() {
      return this.livroFichaAtual === 'TRANSCRICAO'
        ? 'Informe o código do registro anterior'
        : 'Informe o número do registro anterior';
    },

    valorInicialFicha() {
      if (!this.form.fixo) return undefined;
      return {
        codigo: this.form.fixo,
        livroNumero: this.form.livroNumero,
        livroLetra: this.form.livroLetra,
        livroFolha: this.form.livroFolha,
      };
    },
  },

  methods: {
    onChangeTipo() {
      this.form.fixo = null;
      this.limparLivroFicha();
      this.form.coluna1 = null;
      this.form.tipoIndicadorTipo = 'F';
      this.form.tipoIndicadorFixo = 'MATRICULA';
      this.form.tipoIndicadorColuna = null;
      this.validation = {};
    },

    onChangeTipoIndicador() {
      this.form.tipoIndicadorFixo = 'MATRICULA';
      this.form.tipoIndicadorColuna = null;
      this.$delete(this.validation, 'tipoIndicadorFixo');
      this.$delete(this.validation, 'tipoIndicadorColuna');
    },

    selecionarFicha(fichas, add, campoValidado, mensagemValidacao, livroSelecionado) {
      const ficha = fichas?.[0];
      this.form.fixo = ficha?.codigo?.toString() || null;
      if (this.form.fixo) this.$delete(this.validation, 'numero');

      this.form.livroNumero = ficha?.livroNumero || null;
      this.form.livroLetra = ficha?.livroLetra || null;
      this.form.livroFolha = ficha?.livroFolha || null;

      if (!this.isMatriculaExterna) return;

      this.form.tipoIndicadorFixo = livroSelecionado || ficha?.tipo || this.form.tipoIndicadorFixo;
    },

    montarTipoIndicador() {
      if (this.form.tipoNumero === 'F') {
        return {tipo: 'F', fixo: this.form.tipoIndicadorFixo, coluna: null};
      }
      return {
        tipo: this.form.tipoIndicadorTipo,
        fixo: this.form.tipoIndicadorTipo === 'F' ? this.form.tipoIndicadorFixo : null,
        coluna: this.form.tipoIndicadorTipo === 'C' ? this.form.tipoIndicadorColuna : null,
      };
    },

    limparLivroFicha() {
      this.form.livroNumero = null;
      this.form.livroLetra = null;
      this.form.livroFolha = null;
    },

    cancelar() {
      FrontBusiness.closeModal();
    },

    salvar() {
      this.validation = {};
      let hasError = false;

      if (!this.form.tipo) {
        this.$set(this.validation, 'tipo', 'Informe o tipo de registro anterior');
        hasError = true;
      }

      if (this.form.tipoNumero === 'F' && !this.form.fixo) {
        this.$set(this.validation, 'numero', this.mensagemNumeroObrigatorio);
        hasError = true;
      }

      if (this.form.tipoNumero === 'C' && !this.form.coluna1) {
        this.$set(this.validation, 'numero', 'Selecione a coluna');
        hasError = true;
      }

      if (this.isMatriculaExterna && !this.form.serventia) {
        this.$set(this.validation, 'serventia', 'Selecione a serventia');
        hasError = true;
      }

      if (this.isMatriculaExterna && this.form.tipoNumero === 'F' && !this.form.tipoIndicadorFixo) {
        this.$set(this.validation, 'tipoIndicadorFixo', 'Selecione o tipo do indicador');
        hasError = true;
      }

      if (this.isMatriculaExterna && this.form.tipoNumero === 'C') {
        if (this.form.tipoIndicadorTipo === 'F' && !this.form.tipoIndicadorFixo) {
          this.$set(this.validation, 'tipoIndicadorFixo', 'Selecione o tipo do indicador');
          hasError = true;
        }
        if (this.form.tipoIndicadorTipo === 'C' && !this.form.tipoIndicadorColuna) {
          this.$set(this.validation, 'tipoIndicadorColuna', 'Selecione a coluna do tipo do indicador');
          hasError = true;
        }
      }

      if (hasError) return;

      const resultado = {
        tipo: this.form.tipo,
        numero: {
          tipo: this.form.tipoNumero,
          fixo: this.form.tipoNumero === 'F' ? this.form.fixo : null,
          coluna1: this.form.tipoNumero === 'C' ? this.form.coluna1 : null,
          livroNumero: this.form.tipoNumero === 'F' ? this.form.livroNumero : null,
          livroLetra: this.form.tipoNumero === 'F' ? this.form.livroLetra : null,
          livroFolha: this.form.tipoNumero === 'F' ? this.form.livroFolha : null,
        },
        tipoIndicador: this.isMatriculaExterna ? this.montarTipoIndicador() : null,
        serventia: this.isMatriculaExterna ? this.form.serventia : null,
        complemento: this.form.complemento || null,
      };

      FrontBusiness.closeModal(resultado);
    },
  }
}
</script>
